const types = {
  SET_CUSTOMIZE: "SET_CUSTOMIZE",

  SET_CUSTOMIZE_KIND_BREED: "SET_CUSTOMIZE_KIND_BREED",
  SET_CUSTOMIZE_KIND: "SET_CUSTOMIZE_KIND",
  SET_CUSTOMIZE_LABEL_GROUP: "SET_CUSTOMIZE_LABEL_GROUP",
  SET_CUSTOMIZE_LABEL: "SET_CUSTOMIZE_LABEL",

  SET_CUSTOMIZE_SERVICE: "SET_CUSTOMIZE_SERVICE",
  SET_CUSTOMIZE_DISEASE_GROUP: "SET_CUSTOMIZE_DISEASE_GROUP",
  SET_CUSTOMIZE_DISEASE: "SET_CUSTOMIZE_DISEASE",

  SET_CUSTOMIZE_REMINDER: "SET_CUSTOMIZE_REMINDER",

  // StaffList
  SET_CUSTOMIZE_STAFFLIST: "SET_CUSTOMIZE_STAFFLIST",

  RESET: "RESET",
};

const module = {
  namespaced: true,
  state: {
    customize: {},
    kindBreed: [],
    kind: [],
    service: [],
    labelGroup: [],
    label: [],
    diseaseGroup: [],
    disease: [],
    reminder: [],
    staffList: [],    

  },
  actions: {
    actionSetCustomize({ commit }, customize) {
      commit(types.SET_CUSTOMIZE, customize);
    },
    actionSetCustomizeKindBreed({ commit }, kindBreed) {
      commit(types.SET_CUSTOMIZE_KIND_BREED, kindBreed);
    },
    actionSetCustomizeKind({ commit }, kind) {
      commit(types.SET_CUSTOMIZE_KIND, kind);
    },
    actionSetCustomizeLabelGroup({ commit }, labelGroup) {
      commit(types.SET_CUSTOMIZE_LABEL_GROUP, labelGroup);
    },
    actionSetCustomizeLabel({ commit }, label) {
      commit(types.SET_CUSTOMIZE_LABEL, label);
    },
    actionReset({ commit }) {
      commit(types.RESET);
    },
    actionSetCustomizeService({ commit }, service) {
      commit(types.SET_CUSTOMIZE_SERVICE, service);
    },
    actionSetCustomizeDiseaseGroup({ commit }, diseaseGroup) {
      commit(types.SET_CUSTOMIZE_DISEASE_GROUP, diseaseGroup);
    },
    actionSetCustomizeDisease({ commit }, disease) {
      commit(types.SET_CUSTOMIZE_DISEASE, disease);
    },
    actionSetCustomizeReminder({ commit }, reminder) {
      commit(types.SET_CUSTOMIZE_REMINDER, reminder);
    },
    actionSetCustomizeStaffList({ commit }, staffList) {
      commit(types.SET_CUSTOMIZE_STAFFLIST, staffList);
    },   
  },
  mutations: {
    [types.SET_CUSTOMIZE](state, customize = {}) {
      state.customize = customize;
    },
    [types.SET_CUSTOMIZE_KIND_BREED](state, kindBreed = {}) {
      state.kindBreed = kindBreed;
    },
    [types.SET_CUSTOMIZE_KIND](state, kind = {}) {
      state.kind = kind;
    },
    [types.SET_CUSTOMIZE_SERVICE](state, service = {}) {
      state.service = service;
    },
    [types.SET_CUSTOMIZE_LABEL_GROUP](state, labelGroup = {}) {
      state.labelGroup = labelGroup;
    },
    [types.SET_CUSTOMIZE_LABEL](state, label = {}) {
      state.label = label;
    },
    [types.SET_CUSTOMIZE_DISEASE_GROUP](state, diseaseGroup = {}) {
      state.diseaseGroup = diseaseGroup;
    },
    [types.SET_CUSTOMIZE_DISEASE](state, disease = {}) {
      state.disease = disease;
    },
    [types.SET_CUSTOMIZE_REMINDER](state, reminder = {}) {
      state.reminder = reminder;
    },
    [types.SET_CUSTOMIZE_STAFFLIST](state, staffList = {}) {
      state.staffList = staffList;
    },   
    [types.RESET](state) {
      state.customize = {};
      state.kindBreed = [];
      state.kind = [];
    },
  },
  getters: {},
};

export default module;
